// Field Guide theme — small, dependency-free enhancements

document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  // Product gallery thumbnails
  var mainImg = document.getElementById('MainProductImage');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-src');
        mainImg.removeAttribute('srcset');
      });
    });
  }
});
